import React from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { useAuth } from 'utils/providers/AuthProvider'

import { StyledButton } from 'shared'
import OnboardingMenu from './OnboardingMenu'

import { useOnboarding } from 'utils/providers/OnboardingProvider'

const useStyles = makeStyles((theme) => ({
  startButton: {
    marginBottom: '16px',
    borderRadius: '40px',
  },
  startCount: {
    position: 'absolute',
    backgroundColor: theme.palette.error.main,
    borderRadius: '100px',
    display: 'grid',
    placeItems: 'center',
    top: '-8px',
    right: '-8px',
    height: '24px',
    width: '24px',
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.common.white,
  },
}))

export interface IOnboardingMenuStep {
  id: number
  text: string
  checked: boolean
  buttonText: string
  onClick: () => void
}

const Onboarding = () => {
  const classes = useStyles()
  const { user } = useAuth()
  const { steps, uncheckedSteps, onClose, isOpen, onOpen, onStepClick } =
    useOnboarding()

  if (!user || user?.profile?.isOnboardingCompleted) return null

  return (
    <Grid position="relative">
      <StyledButton
        color="secondary"
        variant="contained"
        fullWidth
        className={classes.startButton}
        onClick={onOpen}
      >
        GET STARTED
      </StyledButton>
      <Grid className={classes.startCount}>
        <Typography sx={{ fontWeight: '600' }}>
          {uncheckedSteps || 0}
        </Typography>
      </Grid>
      <OnboardingMenu
        isOpen={isOpen}
        onClose={onClose}
        onStepClick={onStepClick}
        steps={steps}
      />
    </Grid>
  )
}

export default Onboarding
